import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import i from '../imports';
import c from '../components';
import BreadCrumbs from '../partials/BreadCrumbs';
import {Tabs, Tab} from 'react-bootstrap';
import Safe from 'react-safe'

const titleStyle = {
    fontSize: 28,
    fontWeight: "bold",
   }

const textStyle = {
    textAlign: "justify",
    color: "#000000"
}


class Services extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            key: 1
            
        }

    }

    componentDidMount()
    {
        // const script = document.createElement("script");

        // script.src = "https://russiatourism.ru/operators/widget/js/widget.js";
        // script.async = false;
        // script.onload = function () {
        //     console.log('RT loaded');
        //     const myscr = document.createElement("script");
        //     document.body.appendChild(myscr);
        //     const scriptText = document.createTextNode("RT.Widget.build('%D0%A0%D0%A2%D0%9E+021361');");
        //     myscr.appendChild(scriptText);
        // }
        // document.body.appendChild(script);

       
    }

    handleSelect(key) {
        alert(`selected ${key}`);
        this.setState({ key });
      }

    handleChange = (event, value) => {
        this.setState({ value });
      };


    getActiveTabContent = () => {
        let text = Session.model.servicestabs.tabs[this.state.value].text;
        let marked = i.markdown(text);
        return (
            <div className="content-text" style={textStyle}>{marked}</div>
        )
    }

    render() {

        const { value } = this.state;

        let tabMenu = Session.model.servicestabs.tabs;

        return (
            <BasePage data={Session.model.services}>
                <BreadCrumbs fullpath={window.location.pathname} name={""} md={10} />
                <i.Container >
                    <i.Row justify='center' style={{paddingTop:"10px"}}>
                        <i.Col md={7} className="content-text" align="left">
                            <div style={textStyle}>{i.markdown(Session.model.services.text)}</div>
                        </i.Col>
                        <i.Col md={3}>
                            <i.Row direction="column" >
                                {/*
                                <i.Col >
                                    <div dangerouslySetInnerHTML={{ __html:
                                        `<script type="text/javascript" src="https://russiatourism.ru/operators/widget/js/widget.js"></script>
                                        <!-- Russiatourism.ru Widget -->
                                        <div id="russiatourism_widget"></div>
                                        <script type="text/javascript">
                                            alert(document.getElementById("russiatourism_widget"));
                                            RT.Widget.build('%D0%A0%D0%A2%D0%9E+021361');
                                        </script>`
                                    }}>

                                </div>
                                    <div id='russiatourism_widget' style={{height: 59}}></div>
                                </i.Col >
                                */}
                                {/*<i.Col >
                                    <div style={{marginTop: "20px", height:"240px", backgroundImage: `url(${Session.model.services.pic})`, backgroundPosition: 'center', backgroundSize: "cover"}}></div>
                                </i.Col>*/}
                                <i.Col >
                                    <c.ContactInformation data={Session.model.services} />
                                </i.Col>
                            </i.Row>
                        </i.Col>
                    </i.Row>
                    <i.Row justify='center'  style={{paddingTop:"20px"}}>
                        <i.Col md={10} align="center">
                            <TabsMenu menuItems={tabMenu} />
                        </i.Col>
                    </i.Row>
                </i.Container>
            </BasePage>

        );
    }
}

class TabsMenu extends Component {
  constructor(props) {
    super();
    this.state = {
      activeTab: props.activeTab || props.menuItems[0].name
    };
    
    this.handleSelect = this.handleSelect.bind(this);
  }
  
  render() {
    return (
        <Tabs className="services-tabs" activeKey={this.state.activeTab} onSelect={this.handleSelect} id="services-controlled-tab">
        {this.props.menuItems.map(m =>
        <Tab eventKey={m.name} title={m.title}>
            <div className="content-text" style={textStyle}>{i.markdown(m.text)}</div>
        </Tab>)}
    </Tabs> 
    );
  }
  
  handleSelect(selectedTab) {
    // The active tab must be set into the state so that
    // the Tabs component knows about the change and re-renders.
    this.setState({
      activeTab: selectedTab
    });
  }
}

export default Services;